var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M19 1.813 17.187 0 10 7.187 2.813 0 1 1.813 8.187 9 1 16.187 2.813 18 10 10.813 17.187 18 19 16.187 11.813 9z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }